import { isMaster } from "@/util/constants/server"

const COINS_BLOG_SLUGS = [
  "@blog",
  "@dario_en_paragraph",
  "@colin-test-coin-publication",
]

// For now we will keep the global coin flag disabled for master
// TODO: Remove when coins is fully launched
export const COINS_ENABLED = !isMaster

export function getCoinsFlag(blogSlug: string, postTime = Date.now()): boolean {
  const flag =
    process.env.NEXT_PUBLIC_VERCEL_ENV !== "production" &&
    // The post was published after May 27th, 2025
    postTime > 1748304000 &&
    COINS_BLOG_SLUGS.includes(decodeURIComponent(blogSlug))

  return flag
}

/**
 * Coin metrics are getting launched a little bit after coins, so this will remain false for longer.
 */
export function getCoinMetricsFlag(
  blogSlug: string,
  postTime = Date.now()
): boolean {
  const flag =
    process.env.NEXT_PUBLIC_VERCEL_ENV !== "production" &&
    // The post was published after May 27th, 2025
    postTime > 1748304000 &&
    COINS_BLOG_SLUGS.includes(decodeURIComponent(blogSlug))

  return flag
}
